import Layout from "../../shared/Layout";
import React, { useState, useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import DataTable from 'react-data-table-component';
import { DeleteCancelTypeById, GetCancelTypeAll, IsRefundCancelTypeById, SaveCancelType } from "../../../_services";
import { ClipLoader } from 'react-spinners';

const CancelOrderType = () => {
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [cancelTypeData, setCancelTypeData] = useState([]);
    const [isFormopen, setIsFormopen] = useState(false);
    const [cancelTypeId, setCancelTypeId] = useState(null);

    const [formData, setFormData] = useState({
        cancelTypeId: 0,
        actionType: '',
        cancelTypeDescription: '',
        isRefund: false,
        isActive: true,
        isFile: true,
        createdBy: 0
    });

    const fetchCancelTypeAll = async () => {
        try {
            const data = await GetCancelTypeAll();
            if (data.isSuccess === 1) {
                setCancelTypeData((prevData) => {
                    if (JSON.stringify(prevData) !== JSON.stringify(data?.data)) {
                        const sortedData = data?.data?.sort((a, b) => {
                            return new Date(b.createdDate) - new Date(a.createdDate);
                        });

                        return sortedData;
                    }
                    return prevData;
                })
            }
        } catch (error) {
            setCancelTypeData([]);
        }
    };

    useEffect(() => {
        fetchCancelTypeAll();
    }, []);

    const handleChange = (e) => {
        const { name, type, checked } = e.target;

        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : e.target.value
        }));
    };

    const onSaveCancelType = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = await SaveCancelType(formData);
            if (data.isSuccess === 200) {
                fetchCancelTypeAll();
                toast.success("Save Successfully");
                handleReset();
                setIsFormopen(false);
                setCancelTypeId(0)
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
        finally {
            setLoading(false);
        }
    };

    const onEditFaq = (item) => {
        setCancelTypeId(item?.cancelTypeId)
        setIsFormopen(true);
        setFormData({
            ...formData,
            cancelTypeId: item?.cancelTypeId,
            cancelTypeDescription: item?.cancelTypeDescription,
            isRefund: item?.isRefund,
            isActive: item?.isActive,
            actionType: item?.actionType,
            isFile: item?.isFile
        })
    }

    const onDeleteCancelTypeById = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");

        if (!isConfirmed) {
            return;
        }
        const data = await DeleteCancelTypeById(id);
        if (data.isSuccess === 1) {
            fetchCancelTypeAll();
            toast.success("Delete Successfully");
        }
    };

    const handleReset = () => {
        setFormData({
            cancelTypeId: 0,
            actionType: '',
            cancelTypeDescription: '',
            isRefund: false,
            isActive: true,
            isFile: false,
            createdBy: 0
        });
    };

    const onClose = () => {
        handleReset();
        setIsFormopen(false);
        setCancelTypeId(0);
    }

    useEffect(() => {
        if (searchTerm) {
            const filtered = cancelTypeData.filter(item =>
                item.cancelTypeDescription.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.actionType.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(cancelTypeData);
        }
    }, [searchTerm, cancelTypeData]);

    const handleRefundToggle = async (row, event) => {
        event.preventDefault();
        try {
            await IsRefundCancelTypeById(row.cancelTypeId);;
            toast.success("Updated Successfully");
            await fetchCancelTypeAll();
        } catch (error) {
            toast.error("Please try again later.");
        }
    };

    const columns = [
        {
            name: 'SR.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'CancelType Description',
            selector: row => row.cancelTypeDescription,
            sortable: false,
        },
        {
            name: 'Action Type',
            selector: row => row.actionType,
            sortable: false,
        },
        {
            name: 'isRefund',
            selector: row => (
                <button
                    type="button"
                    onClick={(e) => handleRefundToggle(row, e)}
                    className={`${row.isRefund ? 'active-toggle' : 'dactive-toggle'}`}
                >
                    {row.isRefund ? "Refund" : "Not Refund"}
                </button>
            ),
            sortable: false
        },
        {
            name: 'isFile',
            selector: row => (
                <button
                    type="button"
                    onClick={(e) => handleRefundToggle(row, e)}
                    className={`${row.isRefund ? 'active-toggle' : 'dactive-toggle'}`}
                >
                    {row.isRefund ? "True" : "False"}
                </button>
            ),
            sortable: false
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span title='Edit' className='edit_icon_wepper' onClick={() => onEditFaq(row)}>
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#526484" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="url(#gradient1)" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </span>
                    <span title='Delete' className="delete_icon_weepr" onClick={() => onDeleteCancelTypeById(row.cancelTypeId)}>
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false
        }
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Cancel Type</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        <div className="search-container col-md-6">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <div className="add_btn">
                            <button onClick={() => setIsFormopen(true)}>Add Cancel Type</button>
                        </div>
                    </div>
                </div>

                <div className="datatable mt-3">
                    <DataTable
                        columns={columns}
                        data={filteredData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>


                <div id="entryformContainer" className={`adminform entryform ${isFormopen ? 'open' : ''}`}>
                    <div className="closebtn">
                        <button className="" onClick={onClose} >
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>
                    <div className="enForm">
                        <div className="text-center form-heading">
                            <h4>Add Cancel Type</h4>
                        </div>
                        <form onSubmit={onSaveCancelType}>
                            <div className="form-group">
                                <label htmlFor="actionType">Action Type</label>
                                <select
                                    id="actionType"
                                    name="actionType"
                                    className="form-control"
                                    value={formData.actionType || ""}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select an Action Type</option>
                                    <option value="Cancel">Cancel</option>
                                    <option value="Return">Return</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="formFile">Cancel Type Description</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="cancelTypeDescription"
                                    name="cancelTypeDescription"
                                    value={formData.cancelTypeDescription}
                                    onChange={handleChange}
                                    placeholder="Description"
                                    required
                                />
                            </div>
                            <div className="form-group d-flex">
                                <div className="form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isRefund" name="isRefund"
                                        checked={formData.isRefund}
                                        onChange={handleChange} />
                                </div>
                                <label htmlFor="exampleFormControlInput1">isRefund</label>
                            </div>
                            <div className="form-group d-flex">
                                <div className="form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isFile" name="isFile"
                                        checked={formData.isFile}
                                        onChange={handleChange} />
                                </div>
                                <label htmlFor="exampleFormControlInput1">isFile</label>
                            </div>

                            <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                                <div className="submit-btn pt-2">
                                    <button
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <ClipLoader color="#fff" size={20} />
                                        ) : (
                                            cancelTypeId ? 'Update' : 'Submit'
                                        )}
                                    </button>
                                </div>
                                <div className="reset-btn pt-2">
                                    <button onClick={handleReset}>Reset</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default CancelOrderType;